import {css} from '@emotion/css';
import {spacing, fonts, colours} from '../../../../styles/js/variables';
import {layout, Breakpoints, mq} from '../../../../styles/js/mixins';

const styles = {
  headerDrawer: (isOpen: boolean): string => css`
    label: headerDrawer;
    height: 0;
    padding: 0;
    overflow: hidden;
    background-color: ${colours.background.GRAY};
    ${isOpen
      ? `
      height: auto;
      padding: ${spacing.XS};
    `
      : ''}
  `,
  linksContainer: css`
    label: linksContainer;
    ${layout.containerStackMobile};
    justify-content: stretch;
    margin: 0 auto;

    ${mq(Breakpoints.DESKTOP)} {
      max-width: ${Breakpoints.DESKTOP_LG / 10}rem;
      padding: 0 ${spacing.XXS};
    }
  `,
  linkContainerColumn: css`
    label: linkContainerColumn;
    ${layout.columnStackableMobile(spacing.XS)};
    flex: 1 1 100%;

    ${mq(Breakpoints.TABLET)} {
      &:not(:first-of-type) {
        padding-left: ${spacing.XXS};
      }
      &:not(:last-of-type) {
        padding-right: ${spacing.XXS};
      }
    }
  `,
  headerDrawerLink: (isPrimary: boolean): string => css`
    label: headerDrawerLink;
    display: flex;
    margin-bottom: ${spacing.XXXS};
    padding: 0.7rem 1rem;
    color: ${colours.font.BLACK};
    line-height: 1;
    text-decoration: none;
    background-color: ${colours.general.WHITE};

    ${isPrimary
      ? `
        padding-top: 1.2rem; 
        padding-bottom: 1.2rem;
        color: ${colours.brand.SECONDARY};
        font-weight: ${fonts.weight.SEMI_BOLD};
        `
      : ''}

    &:last-of-type {
      margin-bottom: 0;
    }
  `,
};

export default styles;
